export default __webpack_public_path__ + "static/media/betaBell.35b89220.svg";